import React from 'react';

const TermsOfUse: React.FC = () => {
  return (
    <div style={{
      fontFamily: "'Roboto', sans-serif",
      maxWidth: '1100px',
      margin: '40px auto',
      padding: '20px 40px',
      lineHeight: 1.7,
      color: '#333',
      backgroundColor: '#fff',
      minHeight: '100vh',
      textAlign: 'left'
    }}>
      <h1 style={{
        textAlign: 'left',
        fontWeight: 500,
        fontSize: '1.8em',
        marginBottom: '30px'
      }}>Terms of Use</h1>

      <p style={{ marginBottom: '1.2em' }}>
        By accessing or using our climbing application ("CruxLabs"), you agree to be bound by the following Terms of Use. If you do not agree with these terms, please do not use the App.
      </p>

      <h2 style={{ fontWeight: 500, fontSize: '1.3em', marginTop: '30px' }}>1. Use of the App</h2>
      <p style={{ marginBottom: '1.2em' }}>The App provides 3D visualizations of climbing routes, user-contributed beta, and interactive tools for route exploration. You agree to use the App only for lawful and personal purposes.</p>

      <h2 style={{ fontWeight: 500, fontSize: '1.3em', marginTop: '30px' }}>2. User Content</h2>
      <p style={{ marginBottom: '1.2em' }}>Any beta, notes, or contributions you submit must be your own. By submitting content, you grant us the right to display, distribute, and store it within the App. We reserve the right to remove content that violates these terms or applicable laws.</p>

      <h2 style={{ fontWeight: 500, fontSize: '1.3em', marginTop: '30px' }}>3. Accuracy of Information</h2>
      <p style={{ marginBottom: '1.2em' }}>We strive to provide accurate and up-to-date information, but climbing is inherently risky. You agree that you are solely responsible for verifying route conditions and making safe decisions. The App does not replace proper training or local guidance.</p>

      <h2 style={{ fontWeight: 500, fontSize: '1.3em', marginTop: '30px' }}>4. Intellectual Property</h2>
      <p style={{ marginBottom: '1.2em' }}>All original content and software in the App is protected by copyright and trademark law. You may not copy, modify, distribute, or reverse-engineer any part of the App without permission.</p>

      <h2 style={{ fontWeight: 500, fontSize: '1.3em', marginTop: '30px' }}>5. Disclaimer of Warranties</h2>
      <p style={{ marginBottom: '1.2em' }}>The App is provided "as is" without warranties of any kind. We do not guarantee uninterrupted service or error-free operation.</p>

      <h2 style={{ fontWeight: 500, fontSize: '1.3em', marginTop: '30px' }}>6. Limitation of Liability</h2>
      <p style={{ marginBottom: '1.2em' }}>We are not liable for any injuries, losses, or damages resulting from your use of the App, including decisions made based on user-contributed or automatically generated content.</p>

      <h2 style={{ fontWeight: 500, fontSize: '1.3em', marginTop: '30px' }}>7. Changes to the Terms</h2>
      <p style={{ marginBottom: '1.2em' }}>We may update these terms at any time. Continued use of the App after changes are published implies acceptance of the updated terms.</p>

      <h2 style={{ fontWeight: 500, fontSize: '1.3em', marginTop: '30px' }}>8. Contact</h2>
      <p style={{ marginBottom: '1.2em' }}>If you have questions about these Terms, please contact us at <a href="mailto:contact@cruxlabs.app" style={{ color: '#0275d8' }}>contact@cruxlabs.app</a>.</p>

      <p style={{ marginBottom: '1.2em' }}><em>Last updated: August 2025</em></p>
    </div>
  );
};

export default TermsOfUse;
